// extracted by mini-css-extract-plugin
export default {"accordion":"FaqAccordion_accordion__jZyZU","accordion_b_top":"FaqAccordion_accordion_b_top__PqjXc","heading":"FaqAccordion_heading__-hTGD","body":"FaqAccordion_body__E7l6f"};